import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, sessao, fmtData } from '../api';
import { Icone } from '../Icones.jsx';

const hoje = () => new Date().toISOString().slice(0, 10);
const mesPassado = () => {
  const d = new Date(); d.setDate(d.getDate() - 30);
  return d.toISOString().slice(0, 10);
};

// Exporta uma lista de objetos como CSV (abre direto no Excel)
function baixarCSV(nome, colunas, linhas) {
  const esc = v => `"${String(v ?? '').replace(/"/g, '""')}"`;
  const csv = '\uFEFF' + [
    colunas.map(c => esc(c[1])).join(';'),
    ...linhas.map(l => colunas.map(c => esc(typeof c[0] === 'function' ? c[0](l) : l[c[0]])).join(';')),
  ].join('\r\n');
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  a.download = `${nome}.csv`;
  a.click();
}

export default function Relatorios() {
  const u = sessao.usuario;
  const [f, setF] = useState({ de: mesPassado(), ate: hoje(), loja_id: '', fornecedor_id: '', pedido: '' });
  const [lojas, setLojas] = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [d, setD] = useState(null);
  const [erro, setErro] = useState('');

  const carregar = () => {
    const q = new URLSearchParams(Object.entries(f).filter(([, v]) => v)).toString();
    api(`/relatorios?${q}`).then(setD).catch(e => setErro(e.message));
  };
  useEffect(() => { carregar(); }, [f.de, f.ate, f.loja_id]);
  useEffect(() => { api('/lojas').then(setLojas).catch(() => {}); api('/fornecedores').then(setFornecedores).catch(() => {}); }, []);

  const inp = { width: 150 };

  return (
    <div className="grid">
      <h2>Relatórios</h2>
      {erro && <div className="erro">{erro}</div>}

      <div className="card">
        <div className="row">
          <div><label className="label">De</label>
            <input className="input" style={inp} type="date" value={f.de} onChange={e => setF({ ...f, de: e.target.value })} /></div>
          <div><label className="label">Até</label>
            <input className="input" style={inp} type="date" value={f.ate} onChange={e => setF({ ...f, ate: e.target.value })} /></div>
          <div><label className="label">Loja</label>
            <select className="select" style={{ width: 220 }} value={f.loja_id} onChange={e => setF({ ...f, loja_id: e.target.value })}>
              <option value="">Todas</option>
              {lojas.map(l => <option key={l.id} value={l.id}>{l.nome}</option>)}
            </select></div>
          <div><label className="label">Fornecedor</label>
            <select className="select" style={{ width: 190 }} value={f.fornecedor_id}
              onChange={e => setF({ ...f, fornecedor_id: e.target.value })}>
              <option value="">Todos</option>
              {fornecedores.map(fo => <option key={fo.id} value={fo.id}>{fo.nome}</option>)}
            </select></div>
          <div><label className="label">Nº do pedido</label>
            <div className="row" style={{ gap: 6 }}>
              <input className="input" style={{ width: 140 }} value={f.pedido}
                placeholder="buscar pedido…"
                onChange={e => setF({ ...f, pedido: e.target.value })}
                onKeyDown={e => e.key === 'Enter' && carregar()} />
              <button className="btn-sec" onClick={carregar}>Buscar</button>
            </div></div>
        </div>
      </div>

      {d && d.osEncontradas?.length > 0 && (
        <div className="card">
          <h3 className="card-title">OS com o pedido "{f.pedido}" · {d.osEncontradas.length}</h3>
          <table className="tbl">
            <thead><tr><th>OS</th><th>Pedido</th><th>Cliente</th><th>Loja</th><th>Fornecedor</th><th>Caixa</th><th>Status</th></tr></thead>
            <tbody>
              {d.osEncontradas.map(o => (
                <tr key={o.id}>
                  <td><Link to={`/ordens/${o.id}`} style={{ fontWeight: 800, color: 'var(--verde)' }}>{o.numero_os}</Link></td>
                  <td style={{ fontWeight: 700 }}>{o.numero_pedido}</td>
                  <td>{o.cliente}</td><td>{o.loja_nome}</td>
                  <td>{o.fornecedor_nome || '—'}</td><td>{o.caixa || '—'}</td>
                  <td>{o.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!d ? <div className="card">Carregando…</div> : <>
        {/* ===== PERDAS ===== */}
        <div className="card">
          <div className="row" style={{ justifyContent: 'space-between', marginBottom: 10 }}>
            <h3 className="card-title" style={{ marginBottom: 0 }}>Perdas na montagem · {d.perdas.total}</h3>
            {d.perdas.total > 0 && (
              <button className="btn-sec" onClick={() => baixarCSV(`perdas-${f.de}-a-${f.ate}`,
                [[l => fmtData(l.data_hora), 'Data'], ['numero_os', 'OS'], ['cliente', 'Cliente'],
                 ['loja_nome', 'Loja'], ['observacao', 'Motivo'], ['registrado_por', 'Registrado por']],
                d.perdas.lista)}><Icone nome="baixar" size={13} /> Exportar Excel</button>
            )}
          </div>
          {d.perdas.total === 0 ? <p style={{ color: 'var(--cinza)', margin: 0, fontSize: 13.5 }}>Nenhuma perda no período.</p> : (
            <table className="tbl">
              <thead><tr><th>Data</th><th>OS</th><th>Cliente</th><th>Loja</th><th>Motivo</th><th>Registrado por</th></tr></thead>
              <tbody>
                {d.perdas.lista.map((l, i) => (
                  <tr key={i}>
                    <td>{fmtData(l.data_hora)}</td>
                    <td><Link to={`/ordens/${l.os_id}`} style={{ fontWeight: 800, color: 'var(--verde)' }}>{l.numero_os}</Link></td>
                    <td>{l.cliente}</td><td>{l.loja_nome}</td>
                    <td style={{ maxWidth: 280 }}>{l.observacao}</td><td>{l.registrado_por}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* ===== DIVERGÊNCIAS ===== */}
        <div className="card">
          <div className="row" style={{ justifyContent: 'space-between', marginBottom: 10 }}>
            <h3 className="card-title" style={{ marginBottom: 0 }}>
              Divergências · {d.divergencias.total} ({d.divergencias.pendentes} pendentes)
            </h3>
            {d.divergencias.total > 0 && (
              <button className="btn-sec" onClick={() => baixarCSV(`divergencias-${f.de}-a-${f.ate}`,
                [[l => fmtData(l.criado_em), 'Data'], ['numero_os', 'OS'], ['cliente', 'Cliente'],
                 ['loja_nome', 'Loja'], ['vendedor', 'Vendedor(a)'], ['descricao', 'Divergência'],
                 [l => l.resolvida ? 'Resolvida' : 'Pendente', 'Situação'], ['registrado_por', 'Registrado por']],
                d.divergencias.lista)}><Icone nome="baixar" size={13} /> Exportar Excel</button>
            )}
          </div>
          {d.divergencias.total === 0 ? <p style={{ color: 'var(--cinza)', margin: 0, fontSize: 13.5 }}>Nenhuma divergência no período.</p> : <>
            <table className="tbl">
              <thead><tr><th>Data</th><th>OS</th><th>Loja</th><th>Vendedor(a)</th><th>Divergência</th><th>Situação</th></tr></thead>
              <tbody>
                {d.divergencias.lista.map((l, i) => (
                  <tr key={i}>
                    <td>{fmtData(l.criado_em)}</td>
                    <td><Link to={`/ordens/${l.os_id}`} style={{ fontWeight: 800, color: 'var(--verde)' }}>{l.numero_os}</Link></td>
                    <td>{l.loja_nome}</td><td>{l.vendedor || '—'}</td>
                    <td style={{ maxWidth: 280 }}>{l.descricao}</td>
                    <td>
                      <span className="badge" style={l.resolvida
                        ? { background: '#e2f3e8', color: 'var(--ok)' }
                        : { background: '#fdecec', color: 'var(--vermelho)' }}>
                        {l.resolvida ? 'Resolvida' : 'Pendente'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="row" style={{ marginTop: 14, alignItems: 'start' }}>
              <div style={{ flex: 1 }}>
                <h3 className="card-title">Por loja</h3>
                <table className="tbl"><tbody>
                  {d.divergencias.rankLoja.map((r, i) => (
                    <tr key={i}><td>{r.nome}</td><td style={{ fontWeight: 800, width: 50 }}>{r.qtd}</td></tr>
                  ))}
                </tbody></table>
              </div>
              <div style={{ flex: 1 }}>
                <h3 className="card-title">Por vendedor(a)</h3>
                <table className="tbl"><tbody>
                  {d.divergencias.rankVend.map((r, i) => (
                    <tr key={i}><td>{r.vendedor} <span style={{ color: 'var(--cinza)', fontSize: 12 }}>· {r.loja_nome}</span></td>
                      <td style={{ fontWeight: 800, width: 50 }}>{r.qtd}</td></tr>
                  ))}
                </tbody></table>
              </div>
            </div>
          </>}
        </div>

        {/* ===== PRODUÇÃO ===== */}
        <div className="card">
          <div className="row" style={{ justifyContent: 'space-between', marginBottom: 10 }}>
            <h3 className="card-title" style={{ marginBottom: 0 }}>Produção por loja</h3>
            <button className="btn-sec" onClick={() => baixarCSV(`producao-${f.de}-a-${f.ate}`,
              [['loja_nome', 'Loja'], ['criadas', 'OS criadas'], ['concluidas', 'Concluídas'],
               ['tempo_medio_dias', 'Tempo médio (dias)']], d.producao)}><Icone nome="baixar" size={13} /> Exportar Excel</button>
          </div>
          <table className="tbl">
            <thead><tr><th>Loja</th><th>OS criadas</th><th>Concluídas</th><th>Tempo médio (digitação → entrega)</th></tr></thead>
            <tbody>
              {d.producao.map((l, i) => (
                <tr key={i}>
                  <td style={{ fontWeight: 700 }}>{l.loja_nome}</td>
                  <td>{l.criadas}</td>
                  <td>{Number(l.concluidas) || 0}</td>
                  <td>{l.tempo_medio_dias != null ? `${l.tempo_medio_dias} dias` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>}
    </div>
  );
}
